export const getApiBaseUrl = (): string => {
    const base = process.env.NEXT_PUBLIC_PLUGINS_DB_API_ENDPOINT;
    if (base && base.trim().length > 0) {
        return base.endsWith('/') ? base.slice(0, -1) : base;
    }

    return '/api';
};

export const buildApiUrl = (path: string, origin?: string): string => {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    const base = getApiBaseUrl();
    const normalizedBase = base.endsWith('/') ? base.slice(0, -1) : base;

    if (normalizedBase.startsWith('http')) {
        return `${normalizedBase}${normalizedPath}`;
    }

    const fallbackOrigin = origin ?? process.env.NEXT_PUBLIC_WEBSITE_URL;
    if (fallbackOrigin) {
        const normalizedOrigin = fallbackOrigin.endsWith('/') ? fallbackOrigin.slice(0, -1) : fallbackOrigin;
        return `${normalizedOrigin}${normalizedBase}${normalizedPath}`;
    }

    return `${normalizedBase}${normalizedPath}`;
};
